import HomePage from './HomePage';
import HomePageContainer from './HomePage.container';

export default HomePageContainer(HomePage);
